import { useWatch } from '@redwoodjs/forms'

import Input from 'src/components/widgets/Input/Input'
import type { InputProps } from 'src/components/widgets/Input/Input'
import useField from 'src/lib/hooks/form/useField'

import SheetButton, {
  SheetButtonProps,
} from '../buttons/SheetButton/SheetButton'

export type RevealInputProps = InputProps &
  Omit<SheetButtonProps, 'type'> & {
    title: string
    revealed?: boolean
    testid: string
  }

const RevealInput: React.FC<RevealInputProps> = ({
  title,
  revealed = false,
  testid,

  ...props
}) => {
  const [reveal, setReveal] = React.useState(revealed)

  const value = useWatch({ name: props.name })
  const field = useField<string | null>(props.name)

  return (
    <>
      {!value && !reveal ? (
        <SheetButton
          onClick={() => {
            field.onChange('')
            setReveal(true)
          }}
          title={title}
          w="full"
          data-testid={testid}
        />
      ) : (
        <Input
          {...props}
          clearable
          onClear={() => {
            field.onChange(null)
            setReveal(false)
          }}
          data-testid={testid}
          w="full"
        />
      )}
    </>
  )
}

export default RevealInput
